import "./UserIcon.css";
import React from "react";
import PropTypes from "prop-types";

export default class UserIcon extends React.Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        isImpersonating: PropTypes.bool,
        isSales: PropTypes.bool
    };

    getEmployerIcon(user) {
        let employerIcon = null;
        if (user) {
            if (user.employerThumbnail) {
                employerIcon = (
                    <div className="small-thumbnail-overlay employer-thumbnail-overlay small-outlined-thumbnail-overlay">
                        <img role="presentation" src={user.employerThumbnail} alt="Employer logo" />
                    </div>
                );
            }
        }
        return employerIcon;
    }

    getMemberIcon(member, isImpersonating) {
        let memberIcon = null;
        if (isImpersonating) {
            memberIcon = (
                <div className="outlined-thumbnail-overlay">
                    <span className="impersonating-thumb thumb">
                        <i className="icon-eye" />
                    </span>
                </div>
            );
        } else if (member) {
            if (member.firstName && member.lastName) {
                let initials = member.firstName.substring(0, 1) + member.lastName.substring(0, 1);
                memberIcon = (
                    <div className="outlined-thumbnail-overlay">
                        <span className="initials-thumb thumb">{initials}</span>
                    </div>
                );
            }
        } else {
            memberIcon = (
                <div className="thumbnail-overlay">
                    <span className="default-thumb thumb" />
                </div>
            );
        }
        return memberIcon;
    }

    render() {
        const {
            isImpersonating,
            user,
            isSales,
            isEmployer
        } = this.props;

        return (
            <div className="user-icon-container">
                {isEmployer &&
                    this.getEmployerIcon(user)
                }
                {isSales &&
                    <div className="small-thumbnail-overlay sales-thumbnail-overlay">
                        <i className="icon-dollar" />
                    </div>
                }
                {this.getMemberIcon(user, isImpersonating)}
            </div>
        );
    }
}
